import { IonIcon } from "@ionic/react";
import { caretDown, caretUp } from "ionicons/icons";

interface ProfitIndicatorProps {
  profit: number;
}

const ProfitIndicator: React.FC<ProfitIndicatorProps> = ({ profit }) => {
  return (
    <div
      className={`text-xs p-1 rounded justify-center items-center flex w-fit ${
        profit < 0 ? "text-red-400 bg-red-900" : "text-green-400 bg-green-900"
      }`}
    >
      {profit < 0 ? <IonIcon icon={caretDown} /> : <IonIcon icon={caretUp} />}
      {(profit || 0).toFixed(2)}%
    </div>
  );
};

export default ProfitIndicator;
